import { UserFindDto, type UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import { Connection1cFindDto, type Connection1cFindInterface } from '@zaoblako/shared/modules/integration/dtos/connection-1c/connection-1c-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';

import * as yup from 'yup';

/** Other financial flow response body - DTO signature */
export interface OtherFinancialFlowFindInterface {
  /** Unique identifier. Cannot be changed. */
  id: number;

  // Tech columns
  /** Creation date and type */
  created: Date;
  /** Last update date and type */
  updated: Date;
  /** Soft deletion date and type */
  deleted?: Date;
  /** Creator user */
  createdBy?: UserFindInterface;

  // Data columns
  /** Flow display name */
  name: string;
  /** Flow 1C ERP reference ID */
  erp1cRef: string;
  /** Flow 1C ERP reference ID */
  isFolder: boolean;
  /** Flow 1C ERP database */
  connection: Connection1cFindInterface;
}

/** Other financial flow response body - DTO schema */
export const OtherFinancialFlowFindDto = SerdeDtoClass.create<OtherFinancialFlowFindInterface>(CatalogDtosKeysEnum.OTHER_FINANCIAL_FLOW_FIND_DTO, {
  id: {
    label: 'Номер',
    sortable: true,
    serializer: yup.number(),
  },
  created: {
    sortable: true,
    label: 'Созданы',
    serializer: yup.date(),
  },
  updated: {
    label: 'Изменены',
    serializer: yup.date(),
  },
  deleted: {
    optional: true,
    label: 'Удалены',
    serializer: yup.date(),
  },
  createdBy: {
    sortable: true,
    optional: true,
    nested: UserFindDto,
    label: 'Автор',
    serializer: (_, nested) => nested,
  },
  name: {
    sortable: true,
    label: 'Название',
    serializer: yup.string(),
  },
  erp1cRef: {
    label: 'Ссылочный номер в 1С',
    serializer: yup.string(),
  },
  isFolder: {
    label: 'Является каталогом',
    serializer: yup.boolean(),
  },
  connection: {
    sortable: true,
    nested: Connection1cFindDto,
    label: 'База 1С',
    serializer: (_, nested) => nested,
  },
});
